import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-nav-row' })
export class NavScrollComponent {
	private navLevel: any;

	constructor(private element: HTMLElement) {
		this.navLevel = element.getAttribute('data-nav-level');

		const cols = document.querySelectorAll('.js-nav-col');
		const fullWidth = document.body.clientWidth;
		const containerWidth = this.getContainerWidth();
		const scrollWidth = fullWidth >= 992 ? containerWidth / 3 : containerWidth;
		const activeLevel = +(document.querySelector('.js-nav-row').getAttribute('data-active-level') ?? '1');
		const scrollLevel = fullWidth >= 992 ? (activeLevel > 3 ? activeLevel - 3 : 0) : (activeLevel > 1 ? activeLevel - 1 : 0);
		document.querySelector('.js-nav-row').setAttribute('style', `transform: translateX(calc(-1 * ${scrollLevel} * ${scrollWidth}px))`);
		cols.forEach(col => {
			col.setAttribute('style', `width: ${scrollWidth}px;`);
		});
		this.addResizeListener();
	}

	getContainerWidth() {
		const gutterPx = getComputedStyle(document.querySelector('.js-navbar-sizer')).getPropertyValue('padding-left');
		const gutter = +(gutterPx?.replace('px', '') ?? '0');
		return document.querySelector('.js-navbar-sizer').clientWidth - 2 * gutter;
	}

	addResizeListener() {
		window.addEventListener('resize', () => {
			const cols = document.querySelectorAll('.js-nav-col');
			const fullWidth = document.body.clientWidth;
			const containerWidth = this.getContainerWidth();
			const scrollLevel = fullWidth >= 992 ? (this.navLevel > 2 ? this.navLevel - 3 : 0) : (this.navLevel > 1 ? this.navLevel - 1 : 0);
			const scrollWidth = fullWidth >= 992 ? containerWidth / 3 : containerWidth;
			document.querySelector('.js-nav-row').setAttribute('style', `transform: translateX(calc(-1 * ${scrollLevel} * ${scrollWidth}px))`);
			cols.forEach(col => {
				col.setAttribute('style', `width: ${scrollWidth}px;`);
			});
		});
	}
}
